import React, {useState, useEffect, useRef} from 'react' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faPlay, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Select, MenuItem, InputLabel, FormControl, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from "@date-io/moment";
import moment from "moment";
import FormData from 'form-data'
import { useGetUser } from '../../hooks/useGetUser';
import { useDispatch } from "react-redux"

import { 
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';
import { getDesempenhoLogImportacao, postResultados, getAcoesPorPeriodo } from '../../services/api-auto'
import Paginacao from '../../components/Paginacao';
import exemploDesempenho from '../../assets/docs/modeloApuracao.xlsx'
import LogImportacao from './components/LogImportacao';
import styles from './styles.module.scss'
import { findDOMNode } from 'react-dom';

const Resultados = ({update}) => {

    const ref = useRef(null)
    const [acao, setAcao] = useState({})
    const [mes, setMes] = useState(moment())
    const [dados, setDados] = useState(null)

    const [acaoList, setAcaoList] = useState([])
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [logList, setLogList] = useState([])

    const [loading, setLoading] = useState(false);

    
    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const getAcaoList = async () => {
        const info = await getAcoesPorPeriodo( mes.month() + 1, mes.year())
        setAcaoList(info) 
    }

    const getLogList = async () => {
        const info = await getDesempenhoLogImportacao(page)
        setLogList(info.data) 
        setMaxPage(info.maxPage)
    }

    const postImportacao = async () => {
        setLoading(true)
        const formdata = new FormData();
        formdata.append("idAcao", acao.idAcao)
        formdata.append('PeriodoImportacao', mes.format('YYYY-MM-DD'))
        formdata.append('dados', dados)

        try{
            const info = await postResultados(formdata);
            if(Boolean(info.fail)){
            } else{
                showMsgS("Resultados carregados com sucesso")
                setLoading(false);
                getLogList();
            }
        }
        catch {
            showMsgE("Ocorreu um erro e não foi possível carregar os dados")

        }
        finally {
            await update()
            setLoading(false)

        }
    }

    const onFileChange = (event) => {
        let file;
        if (event.target.files && event.target.files[0]) {
            file = event.target.files[0];
            if(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                setDados(file);
            }else{
                showMsgE('Favor escolher arquivos .xlsx')
            }
        }
    };

    const callFileInput = () =>{
        ref.current.click()
    }

    useEffect( () => {
        getLogList();
    },[page])

    useEffect( () => {
        getAcaoList()
    }, [mes])

    const user = useGetUser();

    return(
        <>
            {(user.perfilAcesso === 'Master') && (
                <div className={`${styles.wrapper}`}>
                    <div className={styles.title}>
                        Apuração da campanha
                    </div>
                    <div className={`${styles.actions}`}>
                        <div className={`${styles.card}`}>
                            <div className={`${styles.cardTitle}`}>
                                Orientações
                            </div>
                            <div className={`${styles.modelo}`}>
                                <FormControl>
                                    <Button href={exemploDesempenho} download  className={'customButton bigButton bold'}>
                                        <FontAwesomeIcon icon={faDownload} className={styles.icon}/>
                                        Baixar modelo de planilha
                                    </Button>
                                </FormControl>
                            </div>
                            <div className={`${styles.orientacoes}`}>
                                <ul>
                                    <li>
                                        Clique em "Baixar modelo de planilha" para fazer o download da planilha de importação;
                                    </li>
                                    <li>
                                        A planilha deve estar no formato .xlsx;
                                    </li>
                                    <li>
                                        O arquivo não deve conter células mescladas;
                                    </li>
                                    <li>
                                        A primeira linha deve conter o cabeçalho das colunas;
                                    </li>
                                    <li>
                                        Deve haver somente uma aba no arquivo;
                                    </li>
                                    <li>
                                        Após a importação, veja o resultado de cada registro clicando nos números processados;
                                    </li>
                                    <li className={`${styles.highlight}`} >
                                        No caso de erro no upload, será gerada uma planilha com o descritivo do erro de leitura na última coluna. Favor consultar, ajustar e carregar novamente.
                                    </li>
                                </ul>

                            </div>
                            <div className={`${styles.importacoes}`}>
                                <div className={`${styles.cardTitle}`}>
                                    Importação de resultados
                                </div>
                                <FormControl className={styles.data}>
                                    <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            views={['year', 'month']}
                                            autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            label="Até"
                                            format="MMMM/yyyy"
                                            value={mes}
                                            InputAdornmentProps={{ position: "start" }}
                                            onChange={novaData => { setMes(novaData) }}
                                            className="customFilledInput"
                                            error={false}
                                            invalidDateMessage="Data em formato inválido."
                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                            minDateMessage="Data não deve ser menor que a data mínima."
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                                <FormControl>
                                    <InputLabel id="select-tipo-label" className={styles.label}>
                                        Ação
                                    </InputLabel>
                                    <Select
                                        labelId='select-tipo-label'
                                        label="Ação"
                                        onChange={(e)=>{setAcao(e.target.value)}}
                                        value={acao}
                                        variant='filled'
                                        className="customFilledInput"
                                    >
                                        { acaoList.map( (item) => {
                                            return (<MenuItem value={item} key={item.idAcao}>{item.nome}</MenuItem>)
                                        })}
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    <input type='file' onChange={onFileChange} style={{display: 'none'}} ref={ref}/>
                                    <Button className={`customButton bigButton bold ${dados !== null ? styles.blue : null}`} onClick={callFileInput}>
                                        Adicionar planilha preenchida
                                    </Button>
                                </FormControl>
                                <FormControl>
                                    <Button className={`${styles.processar} bold`} onClick={postImportacao}>
                                        {
                                            !loading ? 
                                            (
                                                <>
                                                    <FontAwesomeIcon icon={faPlay} className={styles.icon}/>
                                                    PROCESSAR PLANILHA
                                                </>
                                            ) :
                                            (
                                                <FontAwesomeIcon icon={faSpinner} className={styles.icon} spin={true}/>
                                            )
                                        }
                                    </Button>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.actions}`}>
                        <div className={`${styles.logs}`}>
                            <div className={`${styles.cardTitle}`}>
                                Log de importação
                            </div>
                            <div>
                                {
                                    logList.map( log =>  (<LogImportacao log={log} key={log.id}/>))
                                }
                            </div>
                            <div className={styles.paginacaoWrapper}>
                            { maxPage > 1 && (
                                <Paginacao maxPage={maxPage} page={page} setPage={setPage}/>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>

    )
}

export default Resultados